<script lang="ts">
  import type { ShapeLinkGroup } from '$lib/sanity/schemas';
  import ShapeLinkGroupComponent from '$components/SanityComponents/Common/ShapeLinkGroup.svelte';
  import type { CustomBlockComponentProps } from '@portabletext/svelte';

  interface Props {
    portableText: CustomBlockComponentProps<ShapeLinkGroup>;
  }

  let { portableText }: Props = $props();
</script>

{#if portableText.value}
  <ShapeLinkGroupComponent document={portableText.value} />
{/if}
